import React from 'react';
import { motion } from 'framer-motion';
import { Section } from '../ui/Section';
import { BellRing, Search, MessageCircle, UserCheck, ShieldAlert } from 'lucide-react';
const steps = [{
  icon: Search,
  title: 'Detecta queda de frequência',
  text: 'O sistema monitora padrões de acesso e identifica mudanças sutis.'
}, {
  icon: BellRing,
  title: 'Notificações estratégicas',
  text: 'Envia mensagens automáticas e personalizadas para reengajar.'
}, {
  icon: ShieldAlert,
  title: 'Identifica riscos',
  text: 'Classifica o risco de churn baseado em comportamento.'
}, {
  icon: MessageCircle,
  title: 'Alertas para a equipe',
  text: 'Avisa sua recepção ou professores para uma abordagem pessoal.'
}, {
  icon: UserCheck,
  title: 'Recuperação',
  text: 'Traz o aluno de volta antes que ele cancele o plano.'
}];
export function RetentionSection() {
  return <Section background="dark" className="relative overflow-hidden" data-id="element-133">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" data-id="element-134">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-135"></div>
      </div>

      <div className="relative z-10" data-id="element-136">
        <div className="text-center mb-16" data-id="element-137">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-138">
            Antes do aluno desistir,{' '}
            <span className="text-[#FF6B35]" data-id="element-139">o sistema age</span>
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-140">
            Um verdadeiro funil de marketing aplicado à retenção da sua
            academia.
          </p>
        </div>

        <div className="max-w-4xl mx-auto" data-id="element-141">
          <div className="space-y-4" data-id="element-142">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-center gap-6 bg-white/5 p-6 rounded-xl border border-white/10 hover:bg-white/10 transition-colors" data-id="element-143">
                <div className="flex-shrink-0 w-12 h-12 rounded-full bg-[#FF6B35]/20 flex items-center justify-center text-[#FF6B35]" data-id="element-144">
                  <step.icon className="h-6 w-6" data-id="element-145" />
                </div>
                <div className="flex-1" data-id="element-146">
                  <h3 className="text-xl font-bold text-white mb-1" data-id="element-147">
                    {step.title}
                  </h3>
                  <p className="text-gray-400" data-id="element-148">{step.text}</p>
                </div>
                <div className="hidden sm:block text-gray-600" data-id="element-149">
                  <div className="w-1 h-8 bg-gradient-to-b from-[#FF6B35] to-transparent opacity-50" data-id="element-150"></div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </Section>;
}